<template>
<section>
	<simplert useRadius=true
	          useIcon=true
	          ref="simplert">
	</simplert>
	<transition name="zoomIn">
		<div class="poper" v-show="show">
			<div class="inner">
				<i @click="hidepop()"></i>
				<div class="title">请输入餐前血糖值</div>
                <div class="input_tip">有效值介于4.4~25</div>
				<div class="input">
					<input type="text" id="typevalue">
				</div>
				<button @click="savedata()">保存</button>
                <div v-if="show_error" class="error_info">请输入有效值</div>
			</div>
		</div>
	</transition>
	<transition name="zoomIn">
		<div class="poper" v-show="show1">
			<div class="inner">
				<i @click="hidepop1()"></i>
				<div class="title">请输入餐后目标值</div>
                <div class="input_tip">有效值介于4.4~15</div>
				<div class="input">
					<input type="text" id="typevalue1">
				</div>
				<button @click="savedata1()">保存</button>
                <div v-if="show_error1" class="error_info">请输入有效值</div>
			</div>
		</div>
	</transition>
		
	<div class="count-wrap bluestyle">
		<div class="count-inner">
			<div class="count-text">碳水化合物</div>
			<countTo
				class="count-num" 
				:separator='theseparator' 
				:startVal='startVal' 
				:endVal='endVal' 
				:duration='2000'
			>
			</countTo>
			<div class="count-text">克</div>
		</div>
	</div>
	
	<div class="chose-wrap">
		<ul>
			<li @click="showpop()">
				<div class="icon-canqian">餐前血糖值</div>
				<div class="icon-arrow-right">
					<span>{{data_canqian}}</span>
				</div>
			</li>
			<li @click="showpop1()">
				<div class="icon-canhou">餐后目标值</div>
				<div class="icon-arrow-right motion">
					{{data_canhou}}
				</div>
			</li>
			<li @click="selectInsulin()">
				<div class="icon-total">一日胰岛素总用量</div>
				<div class="icon-arrow-right">
					<span>{{data_total}}</span>
				</div>
			</li>
			<li @click="selectType()">
				<div class="icon-zhushe">使用胰岛素类别</div>
				<div class="icon-arrow-right">
					{{data_zhushe}}
				</div>
			</li>
		</ul>
	</div>

	<div class="calculate-link" @click="goresult()">计算餐前注射胰岛素</div>

</section>
</template>

<script>
  import Picker from 'better-picker';
  import countTo from 'vue-count-to';
  import Simplert from 'vue2-simplert'
  export default {
    components: { countTo,Simplert },
    computed : {
      dataInsulin () {
        return this.$store.state.dataInsulin
      }
    },
    data () {
      return {
        startVal: 0,
        endVal: 0,
        theseparator:'',
        show_error:false,
        show_error1:false,
        dataInsulinType:[
            {
                text:'速效胰岛素',
                value:'速效'
            },
            {
                text:'短效胰岛素',
                value:'短效'
            }
        ],
        show:false,
        show1:false,
        data_canqian:'',
        data_canhou:'',
        data_total:'',
        data_zhushe:''
      }
    },
    head: {
        title: function () {
            return {
                inner: '餐前注射胰岛素',
                separator: ' ', 
                complement: ' '
            }
        }
    },
    created(){
    	this.endVal = parseInt(this.$route.query.carbo_total)
    },
    methods:{
    	hidepop(){
    		this.show = false
    	},
    	showpop(){
    		this.show = true
    		this.$nextTick(function () {
		        document.getElementById("typevalue").focus()
		    })
    	},
    	hidepop1(){
    		this.show1 = false
    	},
    	showpop1(){
    		this.show1 = true
    		this.$nextTick(function () {
		        document.getElementById("typevalue1").focus()
		    })
    	},
    	selectInsulin(){
            // picker Insulin
            var picker1 = new Picker({
                data: [this.dataInsulin],
                selectedIndex: [5],
                title: '选择一日胰岛素总用量'
            });
            var _that = this
            picker1.on('picker.select', function (selectedVal, selectedIndex) {
                _that.data_total = _that.dataInsulin[selectedIndex[0]].text
            })

            picker1.show()
            // end picker Insulin
        },
        selectType(){
            // picker InsulinType
            var picker2 = new Picker({
                data: [this.dataInsulinType],
                selectedIndex: [0],
                title: '选择胰岛素类别'
            });
            var _that = this
            picker2.on('picker.select', function (selectedVal, selectedIndex) {
                _that.data_zhushe = _that.dataInsulinType[selectedIndex[0]].value
            })
            picker2.show()
            // end picker InsulinType
        },
    	savedata(){
            var result = document.getElementById('typevalue').value
            if(result != ''){
                var regx = /^\d+$|^\d+\.\d{0,1}$/gi;
                var flag = regx.test(result)
                if(flag && result >= 4.4 && result <= 25){
                    if(result.split('.').length > 1 && result.split('.')[1].length != 1){
                        this.show_error = true
                    }else{
                        this.show_error = false
                        this.show = false
                        this.data_canqian = result
                    }
                }else{
                    this.show_error = true
                }
            }else{
                this.show_error = true
            }
            if(this.show_error){
               document.getElementById('typevalue').value = '' 
               document.getElementById('typevalue').focus()
            }
    	},
    	savedata1(){
    		var result = document.getElementById('typevalue1').value
            if(result != ''){
                var regx = /^\d+$|^\d+\.\d{0,1}$/gi;
                var flag = regx.test(result)
                if(flag && result >= 4.4 && result <= 15){
                    if(result.split('.').length > 1 && result.split('.')[1].length != 1){
                        this.show_error1 = true
                    }else{
                        this.show_error1 = false
                        this.show1 = false
                        this.data_canhou = result
                    }
                }else{
                    this.show_error1 = true
                }
            }else{
                this.show_error1 = true
            }
            if(this.show_error1){
               document.getElementById('typevalue1').value = '' 
               document.getElementById('typevalue1').focus()
            }
    	},
    	goresult(){
    		if(!this.data_canqian){
                let obj = {
                    message: '请填写餐前血糖值',
                    type: 'error',
                    customCloseBtnText:'确定'
                }
                this.$refs.simplert.openSimplert(obj)
                return false
            }
            if(!this.data_canhou){
                let obj = {
                    message: '请填写餐后目标值',
                    type: 'error',
                    customCloseBtnText:'确定'
                }
                this.$refs.simplert.openSimplert(obj)
                return false
            }
            if(!this.data_total){
                let obj = {
                    message: '请填写一日胰岛素总用量',
                    type: 'error',
                    customCloseBtnText:'确定'
                }
                this.$refs.simplert.openSimplert(obj)
                return false
            }
            if(!this.data_zhushe){
                let obj = {
                    message: '请填写使用胰岛素类别',
                    type: 'error',
                    customCloseBtnText:'确定'
                }
                this.$refs.simplert.openSimplert(obj)
                return false
            }
            var type_num = 1800
            if(this.data_zhushe == '短效'){
                type_num = 1500
            }
            var result = this.endVal / 15 + (this.data_canqian - this.data_canhou) / (type_num / this.data_total / 18)
            console.log(result)
            result = parseInt(result)
            this.$router.replace({
                path: '/carbofinal',
                query: { unit:result}
            });
    	}
    }
  }
</script>

<style>
.zoomIn-enter-active {
  animation-name: zoomIn;
  animation-duration: .2s;
}
.zoomIn-leave-active {
  animation-name: zoomOut;
  animation-duration: .2s;
}
</style>


// WEBPACK FOOTER //
// carboresult1.vue?4b702d57